import comp0 from '@/app/cookieconsent'
import comp1 from '@/app/cookiebanner'
import comp2 from '@/app/orderboxoverlay'
import comp3 from '@/app/sentry'
import comp4 from '@/app/accountpage'
import comp5 from '@/app/checkoutsuccess'
import comp6 from '@/app/checkout'
import comp7 from '@/app/shoplist'
import comp8 from '@/app/collapsible'
import comp9 from '@/app/qrcode'
import comp10 from '@/app/marquee'
import comp11 from '@/app/formsubmit'
import comp12 from '@/app/countdown'
import comp13 from '@/app/courseform'
import comp14 from '@/app/donationinput'
import comp15 from '@/app/freeproducts'
import comp16 from '@/app/bgvideo'
import comp17 from '@/app/scrollto'
import comp18 from '@/app/contentslider'
import comp19 from '@/app/locationmenulinks'
import comp20 from '@/app/locationdetailbuttons'
import comp21 from '@/app/locationgooglerating'
import comp22 from '@/app/locations'
import comp23 from '@/app/toggleoverlay'
import comp24 from '@/app/loginform'
import comp25 from '@/app/registerconfirm'
import comp26 from '@/app/registerform'
import comp27 from '@/app/selforderinglogin'
import comp28 from '@/app/migrationverify'
import comp29 from '@/app/migration'
import comp30 from '@/app/modaliframe'
import comp31 from '@/app/modalhtml'
import comp32 from '@/app/newslettersubscribe'
import comp33 from '@/app/newsletterunsubscribe'
import comp34 from '@/app/orderfeedback'
import comp35 from '@/app/outdoordelivery'
import comp36 from '@/app/paymentfallback'
import comp37 from '@/app/productpublic'
import comp38 from '@/app/reservationpage'
import comp39 from '@/app/imageslider'
import comp40 from '@/app/statscounter'
import comp41 from '@/app/surveyform'
import comp42 from '@/app/video'
import comp43 from '@/app/vouchersbalance'
import comp44 from '@/app/vouchersbuy'
import comp45 from '@/app/vouchersreload'
import comp46 from '@/app/dialog'
import comp47 from '@/app/loaderglobal'
import comp48 from '@/app/eventlocationform'
import comp49 from '@/app/header'
import comp50 from '@/app/navmeta'
import comp51 from '@/app/loginregisteroverlay'
import comp52 from '@/app/sidebarcart'
import comp53 from '@/app/allergenlist'
import comp54 from '@/app/orderbox'
import comp55 from '@/app/message'
import comp56 from '@/app/passwordresetform'
import comp57 from '@/app/togglesubmenu'
import comp58 from '@/app/referralwidget'
var map={}; 
map['app/cookieconsent']=comp0;
map['app/cookiebanner']=comp1;
map['app/orderboxoverlay']=comp2;
map['app/sentry']=comp3;
map['app/accountpage']=comp4;
map['app/checkoutsuccess']=comp5;
map['app/checkout']=comp6;
map['app/shoplist']=comp7;
map['app/collapsible']=comp8;
map['app/qrcode']=comp9;
map['app/marquee']=comp10;
map['app/formsubmit']=comp11;
map['app/countdown']=comp12;
map['app/courseform']=comp13;
map['app/donationinput']=comp14;
map['app/freeproducts']=comp15;
map['app/bgvideo']=comp16;
map['app/scrollto']=comp17;
map['app/contentslider']=comp18;
map['app/locationmenulinks']=comp19;
map['app/locationdetailbuttons']=comp20;
map['app/locationgooglerating']=comp21;
map['app/locations']=comp22;
map['app/toggleoverlay']=comp23;
map['app/loginform']=comp24;
map['app/registerconfirm']=comp25;
map['app/registerform']=comp26;
map['app/selforderinglogin']=comp27;
map['app/migrationverify']=comp28;
map['app/migration']=comp29;
map['app/modaliframe']=comp30;
map['app/modalhtml']=comp31;
map['app/newslettersubscribe']=comp32;
map['app/newsletterunsubscribe']=comp33;
map['app/orderfeedback']=comp34;
map['app/outdoordelivery']=comp35;
map['app/paymentfallback']=comp36;
map['app/productpublic']=comp37;
map['app/reservationpage']=comp38;
map['app/imageslider']=comp39;
map['app/statscounter']=comp40;
map['app/surveyform']=comp41;
map['app/video']=comp42;
map['app/vouchersbalance']=comp43;
map['app/vouchersbuy']=comp44;
map['app/vouchersreload']=comp45;
map['app/dialog']=comp46;
map['app/loaderglobal']=comp47;
map['app/eventlocationform']=comp48;
map['app/header']=comp49;
map['app/navmeta']=comp50;
map['app/loginregisteroverlay']=comp51;
map['app/sidebarcart']=comp52;
map['app/allergenlist']=comp53;
map['app/orderbox']=comp54;
map['app/message']=comp55;
map['app/passwordresetform']=comp56;
map['app/togglesubmenu']=comp57;
map['app/referralwidget']=comp58;
export default map;